import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { useViewGrouping } from 'components/grouping/views'
import { CommonSeriesSettings, Series, SeriesTemplate } from 'devextreme-react/chart'

export const PageChart: React.FunctionComponent = ({ }) => {
    const { toolbar, parameters } = useViewGrouping()
    return (
        <BPMChart title='Top Page Views' allowedTypes={['bar', 'stackedbar']} type='bar'
            toolBarItems={() => toolbar}
            additionalParams={parameters}
            onRequestLoad={(options, signal) => BPMAnalyticsAPI.getv2<any>(`views`, options, signal)}
        >
            {!parameters.groupBy && <Series name={parameters.countBy == 'view_id' ? 'Views' : 'Users'} />}

            {parameters.groupBy && <SeriesTemplate
                nameField={parameters.groupBy}
            />}

            <CommonSeriesSettings
                type={parameters.groupBy ? 'stackedbar' : 'bar'}
                valueField="count"
                argumentField="name">

            </CommonSeriesSettings>

        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Product/Pages/charts/PageChart.tsx